var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "box" }, [
    _c("div", { staticClass: "p-2" }, [
      _c("h1", { staticClass: "title is-4" }, [_vm._v("Filtros de búsqueda")]),
      _vm._v(" "),
      _c("div", { staticClass: "is-flex is-flex-direction-column" }, [
        _c(
          "div",
          {
            staticClass:
              "is-flex is-flex-direction-row is-align-items-center mb-3",
          },
          [
            this.hasRole([
              _vm.constants.STRINGS.ROLES.LYRIS.ID,
              _vm.constants.STRINGS.ROLES.LYRIS_OR.ID,
            ])
              ? _c(
                  "div",
                  { staticStyle: { flex: "1" } },
                  [
                    _c(
                      "div",
                      { staticClass: "field" },
                      [
                        _c("label", { staticClass: "label" }, [
                          _vm._v("\n              Organización\n            "),
                        ]),
                        _vm._v(" "),
                        !_vm.selectedOrganization
                          ? _c(
                              "b-autocomplete",
                              {
                                staticClass: "input-field",
                                attrs: {
                                  data: _vm.searchOrganizationResults,
                                  placeholder:
                                    "Escriba nombre o id de la organización",
                                  field: "razon_social",
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.getOrganizationsWithInstalledModule(
                                      "aureg"
                                    )
                                  },
                                  select: (option) =>
                                    _vm.selectOrganization(option),
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (props) {
                                        return [
                                          _c("i", {
                                            staticClass: "fas fa-building",
                                          }),
                                          _vm._v(
                                            " " +
                                              _vm._s(props.option.id) +
                                              " - " +
                                              _vm._s(
                                                props.option.razon_social.toUpperCase()
                                              ) +
                                              "\n                "
                                          ),
                                          _c("br"),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "is-size-7" },
                                            [
                                              _vm._v(
                                                _vm._s(props.option.slug) +
                                                  " - " +
                                                  _vm._s(props.option.cuit)
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2290884929
                                ),
                                model: {
                                  value: _vm.organizationInput,
                                  callback: function ($$v) {
                                    _vm.organizationInput = $$v
                                  },
                                  expression: "organizationInput",
                                },
                              },
                              [
                                _vm._v(" "),
                                _c("template", { slot: "empty" }, [
                                  _vm._v(
                                    "No hay resultados para " +
                                      _vm._s(_vm.organizationInput)
                                  ),
                                ]),
                              ],
                              2
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-field",
                      [
                        _vm.selectedOrganization
                          ? _c(
                              "b-tag",
                              {
                                attrs: {
                                  icon: "fas fa-building",
                                  size: "is-medium",
                                  attached: "",
                                  "aria-close-label": "Close tag",
                                  closable: this.canChangeOrganization,
                                },
                                on: {
                                  close: function ($event) {
                                    return _vm.unselectOrganization()
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.selectedOrganization.razon_social.toUpperCase()
                                    ) +
                                    "\n            "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            this.hasRole([
              _vm.constants.STRINGS.ROLES.LYRIS.ID,
              _vm.constants.STRINGS.ROLES.OFICIAL_DE_REGISTRO.ID,
              _vm.constants.STRINGS.ROLES.ADMINISTRADOR_DE_CERTIFICADOS.ID,
            ])
              ? _c(
                  "div",
                  { staticStyle: { flex: "1" } },
                  [
                    _c(
                      "div",
                      { staticClass: "field mr-3" },
                      [
                        _c("label", { staticClass: "label" }, [
                          _vm._v("\n              Usuario\n            "),
                        ]),
                        _vm._v(" "),
                        !_vm.selectedUser
                          ? _c(
                              "b-autocomplete",
                              {
                                staticClass: "input-field",
                                attrs: {
                                  data: _vm.searchUserResults,
                                  placeholder:
                                    "Escriba nombre o apellido del usuario",
                                  field: "apellido",
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.getUsersWithRol("suscriptor")
                                  },
                                  select: (option) => _vm.selectUser(option),
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (props) {
                                        return [
                                          _c("i", {
                                            staticClass: "fas fa-user",
                                          }),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                props.option.apellido.toUpperCase()
                                              ) +
                                              ", " +
                                              _vm._s(props.option.nombre) +
                                              "\n                "
                                          ),
                                          _c("br"),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "is-size-7" },
                                            [
                                              _vm._v(
                                                _vm._s(props.option.cuil) +
                                                  " - " +
                                                  _vm._s(props.option.email)
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1831849808
                                ),
                                model: {
                                  value: _vm.userInput,
                                  callback: function ($$v) {
                                    _vm.userInput = $$v
                                  },
                                  expression: "userInput",
                                },
                              },
                              [
                                _vm._v(" "),
                                _c("template", { slot: "empty" }, [
                                  _vm._v(
                                    "No hay resultados para " +
                                      _vm._s(_vm.userInput)
                                  ),
                                ]),
                              ],
                              2
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-field",
                      [
                        _vm.selectedUser
                          ? _c(
                              "b-tag",
                              {
                                attrs: {
                                  icon: "fas fa-user",
                                  size: "is-medium",
                                  attached: "",
                                  "aria-close-label": "Close tag",
                                  closable: "",
                                },
                                on: {
                                  close: function ($event) {
                                    return _vm.unselectUser()
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.selectedUser.apellido.toUpperCase()
                                    ) +
                                    ", " +
                                    _vm._s(_vm.selectedUser.nombre) +
                                    "\n            "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "is-flex is-flex-direction-row is-align-items-center mb-5",
          },
          [
            _c(
              "b-dropdown",
              {
                attrs: {
                  multiple: "",
                  "aria-role": "list",
                  disabled: !this.availableLabels.length,
                },
                scopedSlots: _vm._u([
                  {
                    key: "trigger",
                    fn: function () {
                      return [
                        _c(
                          "b-button",
                          {
                            attrs: {
                              type: "is-white",
                              "icon-right": "caret-down",
                            },
                          },
                          [
                            _vm._v(
                              "\n              Estados (" +
                                _vm._s(_vm.selectedStates.length) +
                                "/" +
                                _vm._s(_vm.states.length) +
                                ")\n            "
                            ),
                          ]
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.selectedStates,
                  callback: function ($$v) {
                    _vm.selectedStates = $$v
                  },
                  expression: "selectedStates",
                },
              },
              [
                _vm._v(" "),
                _vm._l(this.availableLabels, function (label, i) {
                  return _c(
                    "b-dropdown-item",
                    {
                      key: `label-${i}`,
                      attrs: { value: label, "aria-role": "listitem" },
                      on: {
                        click: function ($event) {
                          return _vm.addState(label)
                        },
                      },
                    },
                    [_c("span", [_vm._v(_vm._s(label))])]
                  )
                }),
              ],
              2
            ),
            _vm._v(" "),
            _vm.selectedStates.length
              ? _c(
                  "div",
                  {},
                  _vm._l(_vm.selectedStates, function (state) {
                    return _c(
                      "b-field",
                      {
                        key: state,
                        staticClass: "group-tags",
                        attrs: { grouped: "", "group-multiline": "" },
                      },
                      [
                        _c(
                          "div",
                          {},
                          [
                            _c(
                              "b-tag",
                              {
                                attrs: {
                                  type: "is-primary",
                                  attached: "",
                                  "aria-close-label": "Close tag",
                                  closable: "",
                                },
                                on: {
                                  close: function ($event) {
                                    return _vm.removeState(state)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(state) +
                                    "\n                "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    )
                  }),
                  1
                )
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "is-flex is-flex-direction-row is-align-items-center is-justify-content-space-between",
          },
          [
            _c(
              "b-field",
              { staticClass: "mt-3 ml-3" },
              [
                _c(
                  "b-switch",
                  {
                    attrs: { "true-value": "asc", "false-value": "desc" },
                    on: {
                      input: function ($event) {
                        return _vm.updateListado()
                      },
                    },
                    model: {
                      value: _vm.order,
                      callback: function ($$v) {
                        _vm.order = $$v
                      },
                      expression: "order",
                    },
                  },
                  [_vm._v("Ver más antiguos primero")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "article",
              { staticClass: "field mr-3 mb-3" },
              [
                _c("label", { staticClass: "label" }, [
                  _vm._v(
                    "\n            Mostrar certificados que vencen en\n          "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "b-dropdown",
                  {
                    attrs: { "aria-role": "list" },
                    scopedSlots: _vm._u([
                      {
                        key: "trigger",
                        fn: function () {
                          return [
                            _c("b-button", {
                              staticClass:
                                "is-justify-content-space-between is-fullwidth",
                              attrs: {
                                expanded: "",
                                label: _vm.formattedExpirationDateLabel,
                                type: "is-light",
                                "icon-right": "caret-down",
                              },
                            }),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                    model: {
                      value: _vm.selectedDaysUntilExpiration,
                      callback: function ($$v) {
                        _vm.selectedDaysUntilExpiration = $$v
                      },
                      expression: "selectedDaysUntilExpiration",
                    },
                  },
                  [
                    _vm._v(" "),
                    _c(
                      "b-dropdown-item",
                      { attrs: { value: null, "aria-role": "listitem" } },
                      [_c("span", [_vm._v("No establecido")])]
                    ),
                    _vm._v(" "),
                    _vm._l(this.daysUntilExpires, function (days, i) {
                      return _c(
                        "b-dropdown-item",
                        {
                          key: `selectedDaysUntilExpiration-${i}`,
                          attrs: { value: days, "aria-role": "listitem" },
                        },
                        [_c("span", [_vm._v(_vm._s(days) + " días o menos")])]
                      )
                    }),
                  ],
                  2
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-button",
              {
                staticClass: "is-primary",
                attrs: { "icon-right": "fas fa-broom" },
                on: { click: _vm.emptyFilters },
              },
              [_vm._v("Limpiar filtros")]
            ),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }